module.exports = __webpack_public_path__ + "img/letter_of_wishes.229d798c.svg";